import React, { Fragment } from "react";
import BottomNav from "@/common/layout/bottom-nav";
import Footer from "@/common/layout/Footer";
const NotFoundFooter = () => {
  return <Fragment>
      <div className="h-40 w-full"></div>
      <Footer className="right-0 w-full bg-white px-0 pb-4 shadow-[4px_0px_16px_0px_rgba(0,0,0,0.16)] 2xs:right-[calc(50%-220px)]" data-sentry-element="Footer" data-sentry-source-file="not-found-footer.tsx">
        <BottomNav data-sentry-element="BottomNav" data-sentry-source-file="not-found-footer.tsx" />
      </Footer>
    </Fragment>;
};
export default NotFoundFooter;